import { Grid, IconButton, Drawer, useTheme, Button } from "@mui/material";
import { ChatDots, CloseCircle } from "@solar-icons/react/ssr";
import {
    selectFocusedCommentKey,
    selectOpenComments,
    selectSelectedCellCommentKey,
    setFocusedCommentKey,
    setOpenCommentKey,
    setOpenComments,
} from "@/sheet/bidSlice";
import CommentThread from "@/common/CommentThread";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { store } from "./bidStore";
import { request } from "@/Api";

export const BidComments = ({ bid: paramBid, setRunning }) => {
    const activeBid = paramBid || store.bid;
    const bid = activeBid;
    const comments = bid.root_comments || [];
    const hasRootComments = comments.some((c) => !c.parent_id);
    const theme = useTheme();
    const dispatch = useDispatch();
    const commentsOpen = useSelector(selectOpenComments);
    const focusedCommentKey = useSelector(selectFocusedCommentKey);
    const selectedCellCommentKey = useSelector(selectSelectedCellCommentKey);

    const handleReply = (parentId, commentText) => {
        request.post("/comments", {
            parent_id: parentId,
            description: commentText,
            model_type: "bid",
            model_instance_id: bid.id,
        });
    };

    const handleResolve = (commentId) => {
        request.delete("/comments/" + commentId);
    };

    const handlePromptAddRootComment = () => {
        if (selectedCellCommentKey) {
            gotoCommentKey(selectedCellCommentKey);
        }
    };

    const handleThreadAction = (threadRoot) => {
        const key = threadRoot?.meta?.comment_key;
        gotoCommentKey(key);
    };

    const gotoCommentKey = (key) => {
        const isThreadOnRunning = key.includes("running");
        setRunning(isThreadOnRunning);
        dispatch(setOpenCommentKey(key));
    };

    const handleEdit = (commentId, commentText) => {
        request.patch("/comments/" + commentId, {
            description: commentText,
            model_type: "bid",
            model_instance_id: bid.id,
        });
    };

    const handleCommentInputFocus = (rootComment) => {
        dispatch(setFocusedCommentKey(rootComment?.meta?.comment_key));
    };

    const handleCommentInputBlur = (rootComment) => {
        // dispatch(setFocusedCommentKey(null))
    };

    if (!comments) {
        return null;
    }

    return (
        <Drawer
            onClose={() => {
                dispatch(setOpenComments(false));
            }}
            variant="persistent"
            open={commentsOpen}
            anchor="right"
            ModalProps={{ disableScrollLock: true }}
            PaperProps={{
                sx: {
                    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                    border: "none",
                },
            }}
        >
            <Grid
                container
                display={"flex"}
                flexDirection={"column"}
                style={{
                    padding: 20,
                    paddingLeft: 40,
                    paddingRight: 40,
                    width: 400,
                    background: theme.palette.background.default,
                    height: "100%",
                }}
            >
                <Grid item>
                    <Grid
                        container
                        spacing={1}
                        marginBottom={2}
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Grid item>
                            <Grid container spacing={1}>
                                <Grid item>
                                    <ChatDots />
                                </Grid>
                                <Grid item>
                                    <span>Comments</span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <IconButton
                                size="small"
                                onClick={() => {
                                    dispatch(setOpenComments(false));
                                }}
                            >
                                <CloseCircle size={18} />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
                {hasRootComments && (
                    <Grid item flex={1} overflow={"auto"} height={"100%"}>
                        {comments.map((comment) => {
                            if (comment.parent_id) {
                                return null;
                            }
                            return (
                                <CommentThread
                                    key={comment.id}
                                    rootComment={comment}
                                    onReply={handleReply}
                                    onResolve={handleResolve}
                                    onThreadAction={handleThreadAction}
                                    onEdit={handleEdit}
                                    onInputFocus={handleCommentInputFocus}
                                    onInputBlur={handleCommentInputBlur}
                                    showCommentButton={
                                        comment.meta?.comment_key ==
                                        focusedCommentKey
                                    }
                                />
                            );
                        })}
                    </Grid>
                )}
                {!hasRootComments && (
                    <Grid flex={1} item paddingTop={2} alignItems={"center"}>
                        <Grid
                            container
                            flexDirection={"column"}
                            alignItems={"center"}
                            justifyContent={"center"}
                            height={"100%"}
                        >
                            {selectedCellCommentKey ? (
                                <>
                                    <Grid item>No comments yet</Grid>
                                    <Grid item marginTop={2}>
                                        <Button
                                            onClick={handlePromptAddRootComment}
                                        >
                                            Add Comment
                                        </Button>
                                    </Grid>
                                </>
                            ) : (
                                <Grid item>Select a cell to add comments</Grid>
                            )}
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Drawer>
    );
};
